<template>
  <div class="col-md-12">
    <!-- Date Picker -->
    <div class="week-picker">
      <el-date-picker
        v-model="month"
        type="month"
        @change="monthFilter()"
        placeholder="Pick a month">
      </el-date-picker>
      <el-date-picker
        v-model="week"
        type="week"
        format="Week WW"
        value-format="yyyy-MM-dd"
        :picker-options="{
          firstDayOfWeek: 1
        }"
        @change="weekFilter()"
        placeholder="Pick a week">
      </el-date-picker>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations } from "vuex";
import moment from "moment";

export default {

  data() {
    return {
      date_range: '',
      month: '',
      week: '',
      period:'',
      filter_data:''
    }
  },
  methods:{
    ...mapActions('youtubeDashboard', ['readNewSignups']),
    ...mapMutations('youtubeDashboard', ['setDate']),
    monthFilter() {
      this.week = ''
      let filter_data = {
        date_start: moment(this.month).startOf('month').format("YYYY-MM-DD"),
        date_end: moment(this.month).endOf('month').format("YYYY-MM-DD")

      }
      this.setDate(filter_data)
      this.readNewSignups(filter_data)
    },
    weekFilter() {
      const dateOffset = (24*60*60*1000) * 1; //1 day to fix bug with datepicker
      const dateOffset2 = (24*60*60*1000) * 2; //1 day to fix bug with datepicker
      this.period = this.week
      const start = new Date(this.period)
      start.setTime(start.getTime() - dateOffset);
      const end = new Date(this.period)
      end.setTime(end.getTime() + 3600 * 1000 * 24 * 7 - dateOffset2)
      this.month = ''

      this.filter_data = {
        date_start: moment(start).format("YYYY-MM-DD"),
        date_end: moment(end).format("YYYY-MM-DD")
      }
      this.setDate(this.filter_data)
      this.readNewSignups(this.filter_data)
    }
  },
  computed: {
    auth() {
      return this.$store.state.auth;
    },
    years() {
      return [new Date().getFullYear()]
    },
    currentMonth() {
      return [new Date().getMonth() + 1]
    }
  },
  mounted() {
    this.month = moment().format('Y-M')
    this.filter_data = {
      date_start: moment().startOf('month').format('YYYY-MM-DD'),
      date_end: moment().endOf('month').format('YYYY-MM-DD')
    }

    this.setDate(this.filter_data)
    this.readNewSignups(this.filter_data)
  }
}
</script>
<style scoped>
  .week-picker{
    width: 477px;
    margin: 0 auto;
    padding: 20px;
  }
  .el-date-editor--month{
    margin-right: 37px;
  }
</style>
